import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import { Base64 } from 'js-base64';
import constConfig from '@/util/constConfig';
import app from './modules/app';
import user from './modules/user';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: constConfig.persistName,
  storage: window.localStorage,
  modules: ['appModule'],
  filter: mutation => (
    mutation.type === 'SET_PORJECT_LIST'
    || mutation.type === 'SET_MENU_LIST'
  ),
});

const store = new Vuex.Store({
  modules: {
    appModule: app,
    userModule: user,
  },
  getters: {
    getUser: (state) => {
      const encryptUser = state.userModule.user || {};
      if (!encryptUser.userName && !encryptUser.loginName) {
        return {};
      }
      return {
        userName: Base64.encode(encryptUser.userName || ''),
        loginName: Base64.encode(encryptUser.loginName || ''),
        email: Base64.encode(encryptUser.email || ''),
        mobile: Base64.encode(encryptUser.mobile || ''),
        wechatOpenId: Base64.encode(encryptUser.wechatOpenId || ''),
      };
    },
    getPorjectList: state => state.appModule.projectList || [],
    getMenuList: state => state.appModule.menuList || [],
    getComanyList: state => state.appModule.companyList || [],
  },
  plugins: [vuexLocal.plugin],
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js